<template>
  <div
    class="container"
    v-pageBuried
    :data-page-buried="'BG_H5_UGC_FENXIANG_' + $route.query.tid"
  >
    <div class="download">
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png"
        alt=""
      />
      <div class="center">
        <div class="text1">betterWE星球</div>
        <div class="text2">一站式健康服务平台</div>
      </div>
      <div class="btn">
        <span>打开看看</span>
        <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      </div>
    </div>
    <div v-if="info">
      <!-- 图片轮播 -->
      <div
        class="swipe-content"
        v-if="
          info.detail &&
          info.detail.content_type == 1 &&
          info.base.image_list &&
          info.base.image_list.length
        "
      >
        <van-swipe
          class="my-swipe"
          style="height: 350px"
          :autoplay="10000"
          @change="bindSwipeChange"
        >
          <van-swipe-item
            v-for="(item, index) in info.base.image_list"
            :key="index"
          >
            <van-image
              class="swiper-image"
              fit="contain"
              @click="bindClickImage(info.base.image_list, index)"
              :src="item.url"
            />
          </van-swipe-item>
        </van-swipe>
        <div class="cur"
          >{{ curIndex + 1 }}/{{ info.base.image_list.length }}</div
        >
      </div>
      <!-- 视频播放 -->
      <div
        class="video-content"
        v-if="
          info.detail && info.detail.content_type == 2 && info.detail.video_url
        "
      >
        <video
          controls
          :src="info.detail.video_url"
          webkit-playsinline="true"
          x-webkit-airplay="true"
          playsinline="true"
          x5-playsinline
          preload="auto"
          muted
          :poster="videoPosterUrl"
        ></video>
      </div>
      <div class="dynamic-info">
        <div class="user-info" v-if="info.base.user">
          <div class="avatar-content">
            <van-image class="avatar" :src="info.base.user.u_img" />
            <!-- <img
              class="flag"
              v-if="info.base.user.label_data && info.base.user.label_data.icon"
              :src="info.base.user.label_data.icon"
              alt=""
            /> -->
            <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
          </div>
          <div class="user-center">
            <div class="nickname-content">
              <div class="nickname">{{ info.base.user.u_name }}</div>
              <img
                class="flag"
                v-if="
                  info.base.user.label_data && info.base.user.label_data.icon
                "
                :src="info.base.user.label_data.icon"
                alt=""
              />
            </div>
            <div
              class="desc"
              v-if="
                info.base.user.label_data && info.base.user.label_data.alias
              "
              >{{ info.base.user.label_data.alias }}</div
            >
          </div>
          <div class="focus"
            ><span class="iconfont icon-jiahao"></span><span>关注</span>
            <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
          </div>
        </div>
        <div class="dynamic-title">{{ info.base.title }}</div>
        <!-- 跟吃体测 -->
        <!--  <div class="f-eat-test" v-if="info.base.follow_eat_body_data">
          <div class="test-item">
            <span class="item-name">体重</span
            ><span class="item-num">{{ info.follow_eat_body_data.weight }}</span
            ><span class="item-unit">斤</span>
          </div>
          <div class="test-line"></div>
          <div class="test-item">
            <span class="item-name">腰围</span
            ><span class="item-num">{{ info.follow_eat_body_data.waist }}</span
            ><span class="item-unit">厘米</span>
          </div>
          <div class="test-bottom"></div>
        </div> -->
        <div class="dynamic-words">{{ info.base.desc }}</div>
        <div
          class="tag-list"
          v-if="info.detail.topic_data && info.detail.topic_data.length"
        >
          <div
            class="tag-item"
            v-for="(labelItem, labelIndex) in info.detail.topic_data"
            :key="labelIndex"
            ># {{ labelItem.topic }}
          </div>
          <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
        </div>
        <!-- 跟吃 -->
        <div
          class="f-eat"
          v-if="
            info.detail.follow_eat_info &&
            info.detail.follow_eat_info.user_follow_eat_plan_process
          "
        >
          <div class="f-left">
            <img class="icon" src="" alt="" />
            <div class="text-1"
              >{{ info.detail.follow_eat_info.student_info.u_name }}的{{
                info.detail.follow_eat_info.follow_days
              }}日跟吃计划
            </div>
            <div class="text-2"
              >进度:
              {{ info.detail.follow_eat_info.user_follow_eat_plan_process }}/{{
                info.detail.follow_eat_info.need_card_count
              }}</div
            >
          </div>
          <div class="iconfont icon-you"></div>
        </div>
        <!-- 课程 -->
        <!-- <div class="course-container">
          <img
            class="course-image"
            src="https://btw-common-data-oss.betterwestar.com/btw-admin/resource/ae9c8c88756d5e24438e7cec7eedf680_wh=140_140.png"
            alt=""
          />
          <div class="course-center">
            <div class="course-title">全身循环力量训练</div>
            <div class="course-desc">力量耐力训练：腿、臀、腹</div>
          </div>
          <div class="course-get">Get同款</div>
          <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
        </div> -->
        <div class="add-time">{{ info.base.create_time | filterTime }}</div>
        <div
          class="flower-container"
          v-if="flowerInfo && tabType != 'weapp_group'"
        >
          <flowerComponent
            v-model="flowerInfo.flag"
            class="flower-component"
            @flower="bindSendFlower"
          />
          <div class="flower-text">
            {{ flowerInfo.count | fliterFlowerText }}</div
          >
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" @load="getComment">
        <AppComment
          :data="commentData"
          :total="info.base.comment_info.number"
          :finished="finished"
        ></AppComment>
      </van-list>
    </div>
    <div class="not-data" v-if="!info && loaded">
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d3be9ea8aa66beb90fd4d31cda0a6a9f.png"
        alt=""
      />
      <div>该动态被删除或不存在</div>
    </div>
    <div class="download-btn">
      <span>App 内打开</span>
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
    </div>
  </div>
</template>
<script>
import flowerComponent from './components/flower.vue'
import AppComment from './comment.vue'
import BetterweWxApi from '@/components/wx/control.js'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import { ImagePreview } from 'vant'
export default {
  components: {
    AppComment,
    WxOpenLaunchApp,
    flowerComponent
  },
  data() {
    return {
      flowerInfo: null,
      curIndex: 0,
      info: null,
      loaded: false,
      commentData: [],
      page: 1,
      finished: false,
      loading: false,
      extinfo: '/ugcDetails?tabType=weapp_group_unify&id=',
      tabType: '',
      tid: 0
    }
  },
  filters: {
    filterTime(str) {
      if (str) {
        let res = str.split(' ')[0] || ''
        res = res.replace(/-/g, '.')
        return res
      }
      return ''
    },
    fliterFlowerText(num) {
      if (num) {
        return num + '人送花'
      } else {
        return '送花鼓励一下'
      }
    },
    filterDesc(labels) {
      if (!labels.length) {
        return ''
      }
      return (labels[0] && labels[0].alias) || ''
    },
    filterNum(num) {
      if (num <= 9999) {
        return num
      } else {
        return parseFloat((num / 10000).toFixed(2)) + 'w+'
      }
    }
  },
  computed:{
    videoPosterUrl(){
      if(this.info){
        return `${this.info.detail.video_url}?x-oss-process=video/snapshot,t_0`;
      }else{
        return ''
      }
    },
  },
  created() {
    this.getParams()
    let code = this.$http._getCookie('token')
    //授权token不存在 或者 没有授权
    if (!code) {
      this.bindAuth();
      return
    }
    this.getDetail()
    this.bindGetFlower()
  },
  methods: {
    setShareData(info) {
      let options = {
        title: info.base.title, // 分享标题
        desc: info.base.desc, // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:
          (info.base.image_list &&
            info.base.image_list.length &&
            info.base.image_list[0].url) ||
          '' // 分享图标
      }
      BetterweWxApi.setShareData(options, options)
    },
    getParams() {
      this.sign = this.$route.query.sign || ''
      this.tabType = this.$route.query.tab_type || 'weapp_group_unify'
      this.tid = this.$route.query.tid || 0
      this.extinfo =
        '/ugcDetails?tabType=' +
        encodeURIComponent(this.tabType) +
        '&id=' +
        encodeURIComponent(this.tid)
    },
    bindSwipeChange(index) {
      this.curIndex = index
    },
    isWx() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    bindAuth() {
      if (this.tabType == 'weapp_group') {
        return false
      }
      if (!this.isWx()) {
        return false
      }
      if (!this.$route.query.auth) {
        let url =
          location.href + (location.href.indexOf('?') ? '&auth=1' : '?auth=1')
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_base&next=' +
          encodeURIComponent(url)
        return false
      }
      return true
    },
    async bindGetFlower() {
      if (this.tabType == 'weapp_group') {
        return
      }
      let code = this.$http._getCookie('token')
      let params = {
        group_unify_id: this.tid,
        gym_code: code
      }
      let res = await this.$http
        .getBaseApp('api/v1/UgcSendFlower/getUgcFlowerCount', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          res.data.flag = !!res.data.flag
          this.flowerInfo = res.data
        } else if (res.code == 10000) {
          this.bindAuth()
        } else {
        }
      }
    },
    async bindSendFlower() {
      let code = this.$http._getCookie('token')
      let params = {
        group_unify_id: this.tid,
        flag: +!this.flowerInfo.flag,
        gym_code: code
      }
      let res = await this.$http
        .getBaseApp('api/v1/UgcSendFlower/SendFlower', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (this.flowerInfo.flag) {
            this.flowerInfo.count--
            this.flowerInfo.count =
              this.flowerInfo.count >= 0 ? this.flowerInfo.count : 0
          } else {
            this.flowerInfo.count++
          }
          this.flowerInfo.flag = !this.flowerInfo.flag
        } else if (res.code == 10000) {
          this.$toast('授权失败')
          this.bindAuth()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindClickImage(list, index) {
      let res = list.map((item) => {
        return item.url
      })
      ImagePreview({
        images: res,
        startPosition: index
      })
    },
    getComment() {
      let params = {
        page: this.page,
        sign: this.sign,
        tab_type: this.tabType,
        tid: this.tid,
        headerObj: {
          "clientplatform": 3,
          "clientversion": 282,
        }
      }
      this.$http
        .getBaseApp('member/AppCamp/getComment', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.data = this.dealData(res.data.data)
            if (!res.data.data || !res.data.data.length) {
              this.finished = true
            }
            this.commentData = this.commentData.concat(res.data.data || [])
            this.page++
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.finished = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDetail() {
      let params = {
        tab_type: this.tabType,
        id: this.tid,
        sign: this.sign,
        headerObj: {
          "clientplatform": 3,
          "clientversion": 282,
        }
      }

      // this.$http.getBaseApp("api/v2/Ugc/getUgcDetail", params)
      //this.$http.getBaseApp("member/AppCamp/getGroup", params)
      this.$http
        .getBaseApp('api/v2/Ugc/getUgcDetail', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (
              res.data &&
              Object.prototype.toString.call(res.data) === '[object Object]'
            ) {
              this.info = res.data
            } else {
              this.notData = true
            }
            this.setShareData(this.info)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    dealData(data) {
      data.map((item) => {
        let limit = 2
        item.open = false
        item.showMore = item.comment_list.length > limit ? true : false
        item.realCommentList = item.comment_list.slice(0, limit)
      })
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #f7f7f7;

  .download {
    position: sticky;
    width: 100%;
    height: 56px;
    background-color: #fff;
    box-shadow: 0 0.5px 0 #ededed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    padding: 0px 15px;
    box-sizing: border-box;

    .logo {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }

    .center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .text1 {
        font-size: 15px;
        line-height: 23px;
      }

      .text2 {
        font-size: 12px;
        line-height: 16px;
        color: #999;
      }
    }

    .btn {
      position: relative;
      width: 72px;
      background: #dc0050;
      height: 26px;
      text-align: center;
      border-radius: 13px;
      line-height: 26px;
      font-size: 13px;
      color: #fff;
    }
  }

  .swipe-content {
    background-color: #fff;
    position: relative;

    .cur {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0px 6px;
      text-align: center;
      line-height: 22px;
      border-radius: 11px;
      color: #fff;
      font-size: 12px;
      background: rgba(0, 0, 0, 0.5);
    }
  }

  .my-swipe {
    .swiper-image {
      width: 100%;
      height: 100%;
    }

    ::v-deep .van-swipe__indicators {
      bottom: 24px;
    }

    ::v-deep .van-swipe__indicator:not(:last-child) {
      margin-right: 5px;
    }

    ::v-deep .van-swipe__indicator {
      border-radius: 1px;
      width: 4px;
      height: 7px;
      border-radius: 0px;
      background: rgba(255, 255, 255, 0.3);
      transform: skewX(-20deg);
    }

    ::v-deep .van-swipe__indicator--active {
      background-color: #6236ff;
      background: rgba(255, 255, 255, 1);
    }
  }

  .video-content {
    height: 210px;
    video {
      width: 100%;
      height: 100%;
    }
  }

  .dynamic-info {
    padding: 19px 20px 16px;
    margin-bottom: 8px;
    background-color: #fff;

    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .avatar-content {
        position: relative;
        margin-right: 10px;
        width: 36px;
        height: 36px;

        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      .user-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 6px;

        .nickname-content {
          display: flex;
          align-items: center;

          .flag {
            flex: 0 0 auto;
            margin-left: 6px;
            height: 15px;
          }
        }

        .nickname {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #050b27;
          line-height: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .desc {
          font-size: 12px;
          font-family: PingFang SC;
          color: rgba(5, 11, 39, 0.5);
          line-height: 17px;
        }
      }

      .focus {
        position: relative;
        width: 72px;
        height: 28px;
        border: 1px solid rgba(5, 11, 39, 0.2);
        box-sizing: border-box;
        border-radius: 14px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #050b27;
        line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-weight: normal;
          margin-right: 4px;
        }
      }
    }

    .dynamic-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #050b27;
      line-height: 22px;
      margin-bottom: 10px;
      word-break: break-all;
    }

    .dynamic-words {
      font-size: 14px;
      font-family: PingFang SC;
      color: #050b27;
      line-height: 24px;
      word-break: break-all;
      margin-bottom: 10px;
      white-space: pre-wrap;
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      position: relative;

      .tag-item {
        margin-right: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #4d58a1;
        line-height: 24px;
      }
    }

    .f-eat {
      padding: 0px 10px 0px 13px;
      box-sizing: border-box;
      margin-top: 12px;
      display: flex;
      align-items: center;
      height: 30px;
      background: #e3faf7;
      border-radius: 8px;

      .f-left {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        display: flex;
        align-items: center;

        .icon {
          width: 17px;
          height: 13px;
          object-fit: contain;
          margin-right: 8px;
        }

        .text-1 {
          font-size: 600;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
          max-width: 230px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .text-2 {
          margin-left: 8px;
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.4);
          line-height: 14px;
        }
      }

      .iconfont {
        color: #333333;
        font-weight: 600;
      }
    }

    .f-eat-test {
      position: relative;
      margin-bottom: 4px;
      display: inline-flex;
      align-items: center;
      padding: 0px 2px;

      .test-bottom {
        position: absolute;
        left: 0;
        bottom: -1px;
        width: 100%;
        height: 7px;
        background: #33ce9a;
        border-radius: 5px;
        opacity: 0.12;
      }

      .test-line {
        width: 1px;
        height: 11px;
        opacity: 0.09;
        background-color: #000;
        margin: 0 9px;
      }

      .test-item {
        .item-name {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
          margin-right: 5px;
        }

        .item-num {
          font-size: 14px;
          font-family: DINPro-Black, DINPro;
          font-weight: 900;
          color: #000000;
          line-height: 16px;
          margin-right: 2px;
        }

        .item-unit {
          font-size: 10px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 16px;
        }
      }
    }

    .course-container {
      position: relative;
      margin-top: 16px;
      display: flex;
      align-items: center;
      background: #f7f7f7;
      border-radius: 4px;
      padding: 12px;

      .course-image {
        width: 36px;
        height: 36px;
        object-fit: cover;
        background: #e5e5e5;
        border-radius: 2px;
        overflow: hidden;
        margin-right: 8px;
      }

      .course-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
      }

      .course-title {
        font-weight: bold;
        font-size: 13px;
        color: #050b27;
        line-height: 18px;
        margin-bottom: 2px;
      }

      .course-desc {
        font-size: 12px;
        color: rgba(5, 11, 39, 0.5);
        line-height: 17px;
      }

      .course-get {
        font-weight: bold;
        font-size: 12px;
        color: #050b27;
        line-height: 17px;
      }
    }

    .add-time {
      font-family: PingFangSC, PingFang SC;
      font-size: 12px;
      color: rgba(5, 11, 39, 0.3);
      line-height: 17px;
      margin-top: 16px;
    }
  }

  .flower-container {
    margin-top: 16px;
    padding: 0px 0px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .flower-component {
      margin-bottom: 16px;
    }

    .flower-text {
      position: relative;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
    }

    .flower-text::before {
      content: '';
      width: 46px;
      height: 1px;
      background-color: #dddddd;
      position: absolute;
      left: -12px;
      top: 50%;
      transform: translate(-100%, -50%);
    }

    .flower-text::after {
      content: '';
      width: 46px;
      height: 1px;
      background-color: #ddd;
      position: absolute;
      right: -12px;
      top: 50%;
      transform: translate(100%, -50%);
    }
  }

  .download-btn {
    width: 163px;
    height: 40px;
    position: fixed;
    left: 50%;
    bottom: 68px;
    transform: translate(-50%, 0%);
    border-radius: 20px;
    z-index: 999;
    font-size: 16px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    background: #dc0050;
  }
}

::v-deep .van-list__finished-text {
  background-color: #fff;
  font-size: 12px;
}

.not-data {
  overflow: hidden;
  text-align: center;
  background-color: #fff;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.6);

  .image {
    margin: 20px auto;
    width: 138px;
  }
}
</style>
